export default __webpack_public_path__ + "static/media/scrollRight6.4cc94a27.jpg";